
































































import {Component, Mixins} from 'vue-property-decorator';
import ProductPriorityMethodsMixin from '@/components/product/ProductPriorityMethodsMixin';
import ProductPriorityContent from '@/components/product/ProductPriorityContent.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import ProductPriorityTopContent from '@/components/product/ProductPriorityTopContent.vue';
import ProductPriorityGrid from '@/components/product/ProductPriorityGrid.vue';

@Component({
  components: {
    ProductPriorityContent,
    PageTitle,
    ProductPriorityTopContent,
    ProductPriorityGrid
  }
})
export default class ProductPriority extends Mixins(ProductPriorityMethodsMixin) {}
